import api from "../utils/api";
import { AxiosResponse } from "axios";
import {
  DirectDebitNotificationReportDto,
  MemberFinanceInformationDto,
  SendDirectDebitNotificationsDto,
  UpdateFinanceInformationDto,
  WWFeeInformationDto,
} from "../types/membersTypes";

/**
 * Get the finance information of all members
 * @returns An array of finance information of all members of type MemberFinanceInformationDto
 */
export const getFinanceInformation = async (): Promise<AxiosResponse<MemberFinanceInformationDto[]>> => {
  return await api.get<MemberFinanceInformationDto[]>(`/finance`);
};

/**
 * Get the WW fee information of all members based on the last WW event
 * @returns An array of WW fee information of all members who participated in the last WW event, of type WWFeeInformationDto
 */
export const getWWFeeInformation = async (): Promise<AxiosResponse<WWFeeInformationDto[]>> => {
  return await api.get<WWFeeInformationDto[]>(`/finance/ww-fees`);
};

/**
 * Update the finance information of a specific member
 * @param memberId The ID of the member to update
 * @param updateData The finance information to update
 * @returns A promise that resolves when the update is complete
 */
export const updateFinanceInformation = async (
  memberId: number,
  updateData: UpdateFinanceInformationDto
): Promise<void> => {
  await api.put(`/finance/${memberId}`, updateData);
};

/**
 * Send SEPA direct debit notification emails to the given recipients
 * @param dto The notification payload including recipients and booking details
 * @returns A report of notified and failed members
 */
export const sendDirectDebitNotifications = async (
  dto: SendDirectDebitNotificationsDto
): Promise<DirectDebitNotificationReportDto> => {
  const response = await api.post<DirectDebitNotificationReportDto>(`/finance/direct-debit-notifications`, dto);
  return response.data;
};
